<template>
  <div class="confirmMailForChangeCard">
    <Loading v-show="loading"></Loading>
    <h1>メールアドレスで本人認証</h1>
    <div class="change-inner">
      <table>
        <tr>
          <td><label class="title">お客様のメールアドレス</label></td>
          <td><input type="email" v-model="mail" placeholder="例）calorie@gmail.com"></td>
        </tr>
      </table>
      <button id="register" type="" v-on:click="isConfirmation()">メールに認証メールを送信する</button>
    </div>
  </div>
</template>
<style scoped>
.change-inner{
  width: 60%;
  margin:0 auto;
  background: white;
  text-align: left;
}
.change-inner .title{
  text-align: left;
  width: 30%;
}
.change-inner input{
  width: 70%;
}
.change-inner table{
  width: 100%;
}
 #register{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
  border:0px;
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'ChangeMail',
  components: {
  	Loading
  },
  data () {
    return {
      db: null,
      loading: false,
      mail: null,
      userId: null,
      passcode: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/,
      numberPattern: /^([1-9]\d*|0)$/,
      newMail: null
    }
  },
  methods: {
    isConfirmation: function () {
      if (!this.mail) {
        alert('本人認証で送信するメールアドレスを入力してください。')
        return
      }
      //メールアドレスのバリデーション
      if (!this.mailPattern.test(this.mail)) {
        alert('メールアドレスの入力が正しくありません。')
        return
      }


      this.loading = true

      this.isUser()
 

 /*
      let self = this
      self.loading = true
      var exist = false
      this.db.collection('confirmations').where('mail', '==', this.mail).where('passcode', '==', parseInt(this.passcode, 10)).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          //期限が切れてないかチェック
          self.userId = doc.get('userId')
          var limitdate = doc.get('limitedDate').toDate()
          let now = new Date()
          if (limitdate.getTime() < now.getTime()) {
            exist = false
            alert('パスコードの期限が過ぎております、再度メールアドレスの変更手続きから行ってください。')
            self.loading = false
          } else {
            exist = true
            //新しく登録するアドレスが既存にあるかないか(ないのであれば)
            self.isUser()
          }
        })
        if (!exist) {
          alert('パスコードが正しくありません、再度確認してから新しいメールアドレスの変更手続きをしましょう。')
          self.loading = false
          return
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('新しいメールアドレスの変更に失敗しました。エラーです。')
          self.loading = false
          return
        })*/

    },
    isUser: function () {
      let self = this
      var exist = false
      this.db.collection('users').where('mail', '==', this.mail).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          exist = true
          //メールアドレスへ本人認証メール(口座情報変更用)
          self.sendMail()
        })
        if (!exist) {
        	self.loading = false
        	alert('入力されたメールアドレスは存在しません。')
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('送信に失敗しました。エラーです。')
          self.loading = false
          return
        })
    },
    sendMail: function () {
    	// Functions経由でメール送信
    	let self = this
    	var data = { 'mail': self.mail, 'userId': self.userId}
          $.ajax({
            url: 'https://asia-northeast1-kcal-27d27.cloudfunctions.net/sendConfirmationForChangeCard',
            type: 'GET',
            data: data
          })
            .done(function (data) {
              self.loading = false
              alert('メール送信に成功しました。届いたメールから変更手続きを進めてください。')
            })
            .fail(function () {
              self.loading = false
              alert('メール送信に失敗しました。再度、実行してください。')
            })
    }
  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    firebase.auth().languageCode = 'jp'
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.mail = result['mail']
    this.userId = result['userId']
    if (!this.mail) {
      alert('不正アクセスの可能性があります。')
      location.href='/'
    }
  }
}
</script>
<style type="text/css">

  
</style>


// WEBPACK FOOTER //
// src/components/confirmMailForChangeCard/ConfirmMailForChangeCard.vue